(function () {
  'use strict';

  if (!window.location.pathname.includes('/search')) return;

  /* ── CSS ─────────────────────────────────────────────── */
  var style = document.createElement('style');
  style.textContent = [
    '.n7-pages-section{margin-bottom:2rem}',
    '.n7-search-pages{display:grid;grid-template-columns:repeat(auto-fill,minmax(200px,1fr));gap:14px;margin-top:12px}',
    '.n7-search-page-item{display:flex;flex-direction:column;background:#3a2d1e;border:1px solid rgba(255,162,8,0.2);border-radius:6px;overflow:hidden;text-decoration:none!important;transition:border-color .2s,box-shadow .2s;color:#f5f0e8!important}',
    '.n7-search-page-item:hover{border-color:#FFA208;box-shadow:0 4px 16px rgba(0,0,0,.3)}',
    '.n7-search-page-item__img{width:100%;aspect-ratio:3/2;background:#25201b;overflow:hidden}',
    '.n7-search-page-item__img img{width:100%;height:100%;object-fit:cover;display:block;transition:transform .3s}',
    '.n7-search-page-item:hover .n7-search-page-item__img img{transform:scale(1.04)}',
    '.n7-search-page-item__img-placeholder{width:100%;height:100%;display:flex;align-items:center;justify-content:center;color:rgba(255,162,8,.3)}',
    '.n7-search-page-item__body{padding:10px 12px;display:flex;flex-direction:column;gap:3px}',
    '.n7-search-page-item__label{font-family:sans-serif;font-size:10px;text-transform:uppercase;letter-spacing:.1em;color:#FFA208;font-weight:700}',
    '.n7-search-page-item__title{font-family:Georgia,serif;font-size:14px;font-weight:700;color:#f5f0e8;line-height:1.3}',
    '.n7-search-page-item__excerpt{font-family:sans-serif;font-size:11px;color:#9c8a6e;line-height:1.5;margin-top:2px}',
    '.n7-unavailable{opacity:.6;position:relative}',
    '.n7-unavailable::after{content:"Nicht lieferbar";position:absolute;top:8px;left:8px;background:rgba(0,0,0,.75);color:#bbb;font-family:sans-serif;font-size:10px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;padding:3px 7px;border-radius:3px;pointer-events:none}'
  ].join('');
  document.head.appendChild(style);

  function esc(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var PLACEHOLDER = '<div class="n7-search-page-item__img-placeholder">'
    + '<svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.2">'
    + '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"/>'
    + '<line x1="4" y1="22" x2="4" y2="15"/>'
    + '</svg></div>';

  /* ── Serienbild + Label laden ────────────────────────── */
  /* Prueft ob die Seite eine bekannte Serien-Vorlage verwendet und
     liefert gleichzeitig das Hero-Bild. Ein einziger fetch pro Karte.
     callback(src, label)
       src   = Bild-URL oder null
       label = 'Serie' wenn Zigarren/Wein/Pfeifentabak, sonst null */
  function fetchSerieImage(handle, callback) {
    /* cache: 'no-cache' erzwingt eine Rueckfrage beim Server (bedingter Request
       mit ETag, im Normalfall also nur ein 304). Ohne das liefert Safari eine
       heuristisch gecachte Fassung der Seite aus: Shopify sendet fuer Seiten
       KEINEN Cache-Control-Header, nur ein ETag, und Safari verwendet die alte
       Antwort dann ohne Rueckfrage weiter. Folge war am 22.9.2026, dass die
       Wood-Series-Kachel in Safari-Desktop beim Platzhalter blieb, waehrend
       Chrome und Safari-Mobil das Bild zeigten. */
    fetch('/pages/' + handle, { cache: 'no-cache' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        /* ── Template-Erkennung ────────────────────────── */
        /* Label 'Serie' nur fuer die drei bekannten Vorlagen:
           Zigarren (n7-serie-wrap), Wein (n7-weinserien-page), Pfeifentabak (n7-pfeifentabak-page).
           Andere Seitentypen (z. B. n7lp) zeigen kein Label, aber ggf. trotzdem ein Bild. */
        var isZigarren     = html.indexOf('n7-serie-wrap') !== -1;
        var isWein         = html.indexOf('n7-weinserien-page') !== -1;
        var isPfeifentabak = html.indexOf('n7-pfeifentabak-page') !== -1;
        var isWoodland     = html.indexOf('kwlp-wood-series') !== -1;
        var label = (isZigarren || isWein || isPfeifentabak || isWoodland) ? 'Serie' : null;

        /* ── Bild-Suche ────────────────────────────────── */
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        var selectors = [
          '.n7-series-image-box img',  /* Zigarren, Wein, Pfeifentabak, n7-infopage */
          '.n7lp__hero-img',           /* n7lp-Vorlage (z. B. Summer Edition)        */
          '.kwlp__hero-img',           /* kwlp-Vorlage (Kopp Tobaccos Wood Series)   */
          '.n7ws-hero__img',
          '.n7-serie-header__img img',
          '[id*="zigarrenserie"] img',
          '[id*="weinserien"] img'
        ];

        var imgEl = null;
        for (var i = 0; i < selectors.length && !imgEl; i++) {
          imgEl = doc.querySelector(selectors[i]);
        }

        if (imgEl) {
          var src = imgEl.getAttribute('src') || imgEl.getAttribute('data-src') || '';
          if (src.indexOf('//') === 0) src = 'https:' + src;
          src = src.replace(/width=\d+/, 'width=400');
          if (src && !src.includes('no-image') && !src.includes('logo')) {
            callback(src, label);
            return;
          }
        }
        callback(null, label);
      })
      .catch(function () { callback(null, null); });
  }

  /* ── Seiten-Karte bauen ──────────────────────────────── */
  /* label = Zeichenkette (z. B. 'Serie') oder null (kein Badge) */
  function buildCard(href, titleText, handle, grid) {
    var imgBox = document.createElement('div');
    imgBox.className = 'n7-search-page-item__img';
    imgBox.innerHTML = PLACEHOLDER;

    var labelSpan = document.createElement('span');
    labelSpan.className = 'n7-search-page-item__label';
    /* Platzhalter – wird nach dem fetch gesetzt oder bleibt leer */
    labelSpan.style.visibility = 'hidden';

    var titleSpan = document.createElement('span');
    titleSpan.className = 'n7-search-page-item__title';
    titleSpan.textContent = titleText;

    var body = document.createElement('div');
    body.className = 'n7-search-page-item__body';
    body.appendChild(labelSpan);
    body.appendChild(titleSpan);

    var card = document.createElement('a');
    card.href = href;
    card.className = 'n7-search-page-item';
    card.appendChild(imgBox);
    card.appendChild(body);
    grid.appendChild(card);

    /* Bild UND Label asynchron nachladen (ein einziger fetch) */
    if (handle) {
      (function (box, lbl, title) {
        fetchSerieImage(handle, function (src, detectedLabel) {
          /* Label: nur anzeigen wenn erkannte Serien-Vorlage */
          if (detectedLabel) {
            lbl.textContent = detectedLabel;
            lbl.style.visibility = '';
          } else {
            lbl.parentNode.removeChild(lbl);
          }
          /* Bild */
          if (src) {
            var img = document.createElement('img');
            img.src = src;
            img.alt = title;
            img.loading = 'lazy';
            img.style.cssText = 'width:100%;height:100%;object-fit:cover;display:block;';
            box.innerHTML = '';
            box.appendChild(img);
          }
        });
      })(imgBox, labelSpan, titleText);
    }
  }

  /* ── Fetch-Fallback (keine Seiten im Standard-DOM) ───── */
  function fetchAndShowPages(searchTerm, container, countDiv) {
    var normalUrl = '/search?q=' + encodeURIComponent(searchTerm) + '&type=page';
    fetch(normalUrl)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var pageItems = doc.querySelectorAll('.search-item');
        if (!pageItems.length || document.querySelector('.n7-pages-section')) return;

        var wrapper = document.createElement('div');
        wrapper.className = 'n7-pages-section';
        var h2 = document.createElement('h2');
        h2.className = 'h5 margin-bottom--regular';
        h2.textContent = 'Serien (' + pageItems.length + ')';
        wrapper.appendChild(h2);
        var grid = document.createElement('div');
        grid.className = 'n7-search-pages';
        wrapper.appendChild(grid);
        countDiv.insertAdjacentElement('afterend', wrapper);

        Array.from(pageItems).forEach(function (item) {
          var link = item.querySelector('a');
          var href = link ? link.getAttribute('href') : '#';
          var titleText = link ? link.textContent.trim() : '';
          var handle = href && href.includes('/pages/') ? href.split('/pages/')[1] : null;
          buildCard(href, titleText, handle, grid);
        });
      })
      .catch(function () {});
  }

  /* ── Verfuegbarkeit sortieren ────────────────────────── */
  function sortProductsByAvailability() {
    var grid = document.querySelector('.collection.grid');
    if (!grid) return;
    var available = [], unavailable = [];
    Array.from(grid.children).forEach(function (item) {
      var hasDisabledBtn   = !!item.querySelector('button[disabled]');
      var hasSoldOutClass  = !!item.querySelector('.sold-out, [class*="sold-out"]');
      var hasSoldOutText   = /(nicht lieferbar|sold out|ausverkauft|vergriffen)/i.test(item.textContent);
      if (hasDisabledBtn || hasSoldOutClass || hasSoldOutText) {
        item.classList.add('n7-unavailable');
        unavailable.push(item);
      } else {
        available.push(item);
      }
    });
    available.forEach(function (el) { grid.appendChild(el); });
    unavailable.forEach(function (el) { grid.appendChild(el); });
  }

  /* ── Init ────────────────────────────────────────────── */
  function init() {
    var container = document.querySelector('.gutter-top--large');
    if (!container) return;

    var children = Array.from(container.children);
    var pagesH2   = null;
    var pagesList = null;
    var countDiv  = null;

    children.forEach(function (el) {
      if (el.tagName === 'H2' && el.textContent.includes('Seiten')) {
        pagesH2 = el;
      } else if (el.querySelector && el.querySelector('.search-item')) {
        pagesList = el;
      } else if (el.className && el.className.includes('margin-bottom--large') && el.textContent.includes('Ergebnisse')) {
        countDiv = el;
      }
    });

    var urlParams   = new URLSearchParams(window.location.search);
    var searchTerm  = urlParams.get('q') || '';

    if (pagesH2 && pagesList && countDiv) {
      var pagesWrapper = document.createElement('div');
      pagesWrapper.className = 'n7-pages-section';
      var newH2 = document.createElement('h2');
      newH2.className = 'h5 margin-bottom--regular';
      newH2.textContent = pagesH2.textContent.trim();
      pagesWrapper.appendChild(newH2);
      var grid = document.createElement('div');
      grid.className = 'n7-search-pages';
      pagesWrapper.appendChild(grid);
      countDiv.insertAdjacentElement('afterend', pagesWrapper);
      pagesH2.remove();

      Array.from(pagesList.querySelectorAll('.search-item')).forEach(function (item) {
        var link      = item.querySelector('a');
        var href      = link ? link.getAttribute('href') : '#';
        var titleText = link ? link.textContent.trim() : '';
        var handle    = href && href.includes('/pages/') ? href.split('/pages/')[1] : null;
        buildCard(href, titleText, handle, grid);
      });

      pagesList.remove();
    }

    sortProductsByAvailability();

    if (!pagesH2 && !pagesList && searchTerm && countDiv) {
      fetchAndShowPages(searchTerm, container, countDiv);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    setTimeout(init, 50);
  }

}());